export function SkeletonCard({ height = 80 }) {
  return (
    <div style={{ background: 'white', borderRadius: '14px', padding: '20px', border: '1px solid #eef0f6', height }}>
      <div className="skeleton" style={{ height: '10px', width: '40%', borderRadius: '6px', marginBottom: '16px' }} />
      <div className="skeleton" style={{ height: '28px', width: '30%', borderRadius: '6px' }} />
    </div>
  );
}

export function SkeletonRow() {
  return (
    <div style={{ background: 'white', borderRadius: '12px', padding: '16px', border: '1px solid #f0f0f0', display: 'flex', gap: '12px', alignItems: 'center' }}>
      <div className="skeleton" style={{ width: '44px', height: '44px', borderRadius: '10px', flexShrink: 0 }} />
      <div style={{ flex: 1 }}>
        <div className="skeleton" style={{ height: '12px', width: '35%', borderRadius: '6px', marginBottom: '8px' }} />
        <div className="skeleton" style={{ height: '10px', width: '55%', borderRadius: '6px' }} />
      </div>
      <div className="skeleton" style={{ height: '24px', width: '70px', borderRadius: '20px' }} />
    </div>
  );
}
